type AdvancedMarkerElement = google.maps.marker.AdvancedMarkerElement;

export type PositionedAdvancedMarkerElement = Omit<AdvancedMarkerElement, 'position'> & { position: NonNullable<AdvancedMarkerElement['position']> };
export function isPositionedAdvancedMarkerElement(e: any): e is PositionedAdvancedMarkerElement {
	return e instanceof google.maps.marker.AdvancedMarkerElement && !!e.position;
}
